import * as React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const CashDollarIcon = (props: IconProps): JSX.Element => {
  return (
    <Icon viewBox="0 0 136 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="currentColor" d="M74 52H2l-2-2V10l2-2h72l2 2v40l-2 2ZM4 48h68V12H4v36Z" />
      <path
        fill="currentColor"
        d="M46 28H32v-4h14a2 2 0 0 0 0-4h-6v-2a2 2 0 0 0-4 0v2h-6l-2 2v8l2 2h14v4H30a2 2 0 0 0 0 4h6v2a2 2 0 0 0 4 0v-2h6l2-2v-8l-2-2Zm88 44H62l-2-2V30l2-2h72l2 2v40l-2 2Zm-70-4h68V32H64v36Z"
      />
      <path
        fill="currentColor"
        d="M106 48H92v-4h14a2 2 0 0 0 0-4h-6v-2a2 2 0 0 0-4 0v2h-6l-2 2v8l2 2h14v4H90a2 2 0 0 0 0 4h6v2a2 2 0 0 0 4 0v-2h6l2-2v-8l-2-2Z"
      />
    </Icon>
  );
};
